var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/followed_dock.16fc1ac8.png","uri@2x": __webpack_public_path__ + "static/media/followed_dock.b0943e4e.png","uri@3x": __webpack_public_path__ + "static/media/followed_dock.aa0dee03.png",
    width: 21,
    height: 16
});